document.addEventListener('DOMContentLoaded', function () {
  function poll(m, l, o = !1, p = 1e4, n = 25) {
    m()
      ? l(m())
      : p > 0 &&
        setTimeout(() => {
          poll(m, l, o, o ? p : p - n, n);
        }, n);
  }
  function q(s, o) {
    return o ? s.querySelector(o) : document.querySelector(s);
  }

  const locale = window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en';

  const headingText = locale === 'de' ? 'Was unsere Kunden sagen' : 'What customers are saying';
  const subheadingText = locale === 'de' ? 'Bewertungen' : 'Reviews';
  // console.log('Customer Reviews Widget script loaded');
  const reviewsWidget = document.querySelector('#ReviewsWidget');
  reviewsWidget.classList.add('page-width');
  if (reviewsWidget) {
    if (!reviewsWidget.querySelector('.heading')) {
      const heading = `<div class="heading">${headingText}</div>`;
      reviewsWidget.insertAdjacentHTML('afterbegin', heading);
    }
    if (!reviewsWidget.querySelector('.subheading')) {
      const subheading = `<div class="subheading">${subheadingText}</div>`;
      reviewsWidget.insertAdjacentHTML('afterbegin', subheading);
    }
  }

  // Format rating: one decimal, comma as decimal separator
  poll(
    () =>
      document.querySelector(
        '.R-TextHeading.R-TextHeading--md.R-TextHeading--inline.u-marginBottom--none.u-marginRight--xs.u-verticalAlign--middle'
      ),
    () => {
      const ratingEl = document.querySelector(
        '.R-TextHeading.R-TextHeading--md.R-TextHeading--inline.u-marginBottom--none.u-marginRight--xs.u-verticalAlign--middle'
      );
      //if location is de
      // console.log(
      //   'Shopify locale found:',
      //   window.Shopify.locale,
      //   document.querySelector('.R-TextBody.R-TextBody--xs.u-textLeft--all.u-marginBottom--xs')
      // );

      // poll(
      //   () => window.Shopify && window.Shopify.locale,
      //   () => document.querySelector('.R-TextBody.R-TextBody--xs.u-textLeft--all.u-marginBottom--xs'),
      //   () => {
      console.log('Shopify locale found:', window.Shopify.locale);
      if (window.Shopify && window.Shopify.locale && window.Shopify.locale === 'de') {
        document
          .querySelectorAll('.R-TextBody.R-TextBody--xs.u-textLeft--all.u-marginBottom--xs')
          .forEach(function (el) {
            el.textContent = el.textContent.replace(/Based on (\d+) reviews/, 'Basierend auf $1 Bewertungen');
          });
      }
      // }
      // );

      if (ratingEl) {
        const ratingNum = parseFloat(ratingEl.textContent.replace(',', '.'));
        if (!isNaN(ratingNum)) {
          const formattedRating = ratingNum.toFixed(1).replace('.', ',');
          ratingEl.textContent = formattedRating;
        }
      }
    }
  );

  let visibleCount = 5; // Persist across rerenders

  function fetchAndRenderReviews() {
    poll(
      () => document.querySelector('#sibling-skus'),
      () => {
        // if (window.meta && window.meta.product && window.meta.product.variants) {
        // const skus = window.meta.product.variants.map((variant) => variant.sku).filter(Boolean);
        const skuParam = document.querySelector('#sibling-skus').value;
        const url = `https://api.reviews.io/timeline/data?type=product_review&store=aronmaxx.com-lkqmmzq&sort=date_desc&page=1&per_page=9999&include_sentiment_analysis=true&sku=${skuParam}&lang=en&enable_avatars=true&include_subrating_breakdown=1`;

        fetch(url, {
          headers: {
            accept: 'application/json, text/plain, */*',
            'sec-ch-ua': '"Google Chrome";v="137", "Chromium";v="137", "Not/A)Brand";v="24"',
            'sec-ch-ua-mobile': '?0',
            'sec-ch-ua-platform': '"Windows"',
          },
          referrer: 'https://ironmaxx-new.myshopify.com/',
          referrerPolicy: 'strict-origin-when-cross-origin',
          body: null,
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
        })
          .then((response) => response.json())
          .then((data) => {
            let formattedDates = [];
            // console.log('Fetched reviews data:', data);
            if (data.timeline && Array.isArray(data.timeline)) {
              formattedDates = data.timeline
                .map((item) => {
                  if (item._source && item._source.date_updated) {
                    const dateStr = item._source.date_updated.split(' ')[0];
                    const [yyyy, mm, dd] = dateStr.split('-');
                    return `${dd}.${mm}.${yyyy}`;
                  }
                  // return '';
                })
                .filter(Boolean);
            }

            poll(
              () =>
                document.querySelectorAll('.item__review .item__inner .R-flex-between-xxs .u-flexGrow > div').length,
              () => {
                const reviewDivs = document.querySelectorAll(
                  '.item__review .item__inner .R-flex-between-xxs .u-flexGrow > div'
                );
                const reviewItems = document.querySelectorAll(
                  '.ElementsWidget-prefix .ElementsWidget .R-ContentList .R-ContentList__item'
                );
                const contentList = document.querySelector('.ElementsWidget-prefix .ElementsWidget .R-ContentList');
                if (reviewDivs.length && formattedDates.length && reviewItems.length && contentList) {
                  // reviewDivs.forEach((div, idx) => {
                  //   // Create the wrapper div
                  //   const reviewTextDate = document.createElement('div');
                  //   reviewTextDate.className = 'review-text-date';

                  //   poll(
                  //     () =>
                  //       div
                  //         .closest('.ElementsWidget-prefix .ElementsWidget .R-ContentList .R-ContentList__item')
                  //         .querySelector(
                  //           '.item__inner .u-marginBottom--md .R-TextHeading.R-TextHeading--xxs.u-textLeft--all'
                  //         ),
                  //     () => {
                  //       const reviewText = div
                  //         .closest('.ElementsWidget-prefix .ElementsWidget .R-ContentList .R-ContentList__item')
                  //         .querySelector(
                  //           '.item__inner .u-marginBottom--md .R-TextHeading.R-TextHeading--xxs.u-textLeft--all'
                  //         );

                  //       console.log('Review text found:', reviewText);

                  //       // Insert the wrapper before reviewText

                  //       if (reviewText) {
                  //         if (!reviewText.parentElement.classList.contains('review-text-date')) {
                  //           reviewText.parentNode.insertBefore(reviewTextDate, reviewText);
                  //         }
                  //         // Move reviewText inside the wrapper
                  //         poll(
                  //           () =>
                  //             div
                  //               .closest('.ElementsWidget-prefix .ElementsWidget .R-ContentList .R-ContentList__item')
                  //               .querySelector('.item__review .review-text-date'),
                  //           () => {
                  //             reviewTextDate.appendChild(reviewText);
                  //           }
                  //         );
                  //       }

                  //       // Add the date div
                  //       const reviewDate = document.createElement('div');
                  //       reviewDate.className = 'review-date';
                  //       if (formattedDates[idx]) {
                  //         reviewDate.textContent = formattedDates[idx];
                  //       }
                  //       reviewTextDate.appendChild(reviewDate);
                  //       if (
                  //         !div
                  //           .closest('.ElementsWidget-prefix .ElementsWidget .R-ContentList .R-ContentList__item')
                  //           .querySelector('.item__review .R-RatingStars')
                  //           .querySelector('.review-date')
                  //       ) {
                  //         // Insert the date div after the rating stars
                  //         div
                  //           .closest('.ElementsWidget-prefix .ElementsWidget .R-ContentList .R-ContentList__item')
                  //           .querySelector(
                  //             '.ElementsWidget-prefix .ElementsWidget .R-ContentList .R-ContentList__item .item__review .R-RatingStars'
                  //           )
                  //           .insertAdjacentHTML('beforeend', reviewDate.outerHTML);
                  //       }
                  //     }
                  //   );
                  //   // }
                  // });

                  // reviewDivs.forEach((div, idx) => {
                  //   // Find the review text element
                  //   const reviewText = div
                  //     .closest('.ElementsWidget-prefix .ElementsWidget .R-ContentList .R-ContentList__item')
                  //     .querySelector(
                  //       '.item__inner .u-marginBottom--md .R-TextHeading.R-TextHeading--xxs.u-textLeft--all'
                  //     );

                  //   if (reviewText) {
                  //     // Only wrap if not already wrapped
                  //     if (!reviewText.parentElement.classList.contains('review-text-date')) {
                  //       // Remove any old wrapper if present
                  //       if (
                  //         reviewText.previousElementSibling &&
                  //         reviewText.previousElementSibling.classList.contains('review-text-date')
                  //       ) {
                  //         reviewText.previousElementSibling.remove();
                  //       }
                  //       // Create wrapper and insert before reviewText
                  //       const reviewTextDate = document.createElement('div');
                  //       reviewTextDate.className = 'review-text-date';
                  //       reviewText.parentNode.insertBefore(reviewTextDate, reviewText);
                  //       reviewTextDate.appendChild(reviewText);

                  //       // Add the date div
                  //       const reviewDate = document.createElement('div');
                  //       reviewDate.className = 'review-date';
                  //       if (formattedDates[idx]) {
                  //         reviewDate.textContent = formattedDates[idx];
                  //       }
                  //       reviewTextDate.appendChild(reviewDate);
                  //     }
                  //   }
                  // });

                  reviewDivs.forEach((div, idx) => {
                    const reviewItem = div.closest(
                      '.ElementsWidget-prefix .ElementsWidget .R-ContentList .R-ContentList__item'
                    );
                    const reviewText = reviewItem.querySelector(
                      '.item__inner .u-marginBottom--md .R-TextHeading.R-TextHeading--xxs.u-textLeft--all'
                    );
                    const ratingStars = reviewItem.querySelector('.item__review .R-RatingStars');

                    if (reviewText) {
                      // Only wrap if not already wrapped
                      if (!reviewText.parentElement.classList.contains('review-text-date')) {
                        // Remove any old wrapper if present
                        if (
                          reviewText.previousElementSibling &&
                          reviewText.previousElementSibling.classList.contains('review-text-date')
                        ) {
                          reviewText.previousElementSibling.remove();
                        }
                        // Create wrapper and insert before reviewText
                        const reviewTextDate = document.createElement('div');
                        reviewTextDate.className = 'review-text-date';
                        reviewText.parentNode.insertBefore(reviewTextDate, reviewText);
                        reviewTextDate.appendChild(reviewText);

                        // Add the date div
                        const reviewDate = document.createElement('div');
                        reviewDate.className = 'review-date';
                        if (formattedDates[idx]) {
                          reviewDate.textContent = formattedDates[idx];
                        }
                        reviewTextDate.appendChild(reviewDate);

                        // Insert the date after the rating stars (desktop & mobile)
                        if (ratingStars && !ratingStars.querySelector('.review-date')) {
                          ratingStars.appendChild(reviewDate.cloneNode(true));
                        }
                      }
                    }
                  });

                  // Remove old button if exists
                  const oldBtn = document.getElementById('view-more-reviews-btn');
                  if (oldBtn) oldBtn.remove();

                  // Hide all reviews except first visibleCount
                  reviewItems.forEach((item, idx) => {
                    item.style.display = idx < visibleCount ? '' : 'none';
                  });

                  // Only add button if more than 5 reviews
                  if (reviewItems.length > 5) {
                    const moreBtnText = locale === 'de' ? 'Mehr anzeigen' : 'Show more';

                    const btn = document.createElement('button');
                    btn.id = 'view-more-reviews-btn';
                    btn.textContent = `${moreBtnText}`;

                    btn.addEventListener('click', function () {
                      // Show next 5 reviews
                      const nextCount = Math.min(visibleCount + 5, reviewItems.length);
                      for (let i = visibleCount; i < nextCount; i++) {
                        reviewItems[i].style.display = '';
                      }
                      visibleCount = nextCount;

                      // Hide button if all reviews are now visible
                      if (visibleCount >= reviewItems.length) {
                        btn.style.display = 'none';
                      }
                    });

                    // Only show button if there are hidden reviews
                    if (visibleCount < reviewItems.length) {
                      contentList.insertAdjacentElement('afterend', btn);
                    }
                  }
                }
              }
            );
          })
          .catch((error) => {
            console.error('Error fetching reviews:', error);
          });
        // }
      }
    );
  }

  // Initial run
  setTimeout(() => {
    poll(
      () => document.querySelectorAll('.item__review').length,
      () => {
        fetchAndRenderReviews();
      }
    );
  }, 1000);

  // Responsive placement of .header__group--right
  const mediaElement = document.querySelector('.ElementsWidget-prefix .ElementsWidget .ElementsWidget__media');
  const headerGroupRight = document.querySelector(
    '.ElementsWidget-prefix .ElementsWidget .ElementsWidget__header .header__group--right'
  );
  const headerGroupLeft = document.querySelector('.header__inner');

  if (mediaElement && headerGroupRight && headerGroupLeft) {
    if (window.innerWidth < 750) {
      // Mobile: after media
      mediaElement.insertAdjacentElement('afterend', headerGroupRight);
    } else {
      // Desktop: after header__group--left
      headerGroupLeft.insertAdjacentElement('beforeend', headerGroupRight);
    }
  }

  window.addEventListener('resize', function () {
    const mediaElement = document.querySelector('.ElementsWidget-prefix .ElementsWidget .ElementsWidget__media');
    const headerGroupRight = document.querySelector(
      '.ElementsWidget-prefix .ElementsWidget .ElementsWidget__header .header__group--right'
    );
    const headerGroupLeft = document.querySelector('.header__inner');
    if (mediaElement && headerGroupRight && headerGroupLeft) {
      if (window.innerWidth < 750) {
        mediaElement.insertAdjacentElement('afterend', headerGroupRight);
      } else {
        headerGroupLeft.insertAdjacentElement('beforeend', headerGroupRight);
      }
    }
  });

  // MutationObserver to rerun logic on childList changes
  const contentList = document.querySelector('.ElementsWidget-prefix .ElementsWidget .R-ContentList');
  if (contentList) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          visibleCount = 5; // Reset on rerender
          fetchAndRenderReviews();
        }
      }
    });
    observer.observe(contentList, { childList: true });
  }
});
